import {historyReplaceState} from '@stripe-internal/safe-links';

// remove a search param from the url
export const removeSearchParam = (param: string) => {
  // eslint-disable-next-line @stripe-internal/embedded/no-restricted-globals
  const url = new URL(window.location.href);
  url.searchParams.delete(param);
  historyReplaceState({}, url.toString());
};
